module.exports = __webpack_public_path__ + "static/media/rabby.add404a1.svg";